import { StateCreator } from 'zustand';

export interface MapControlSlice {
  showInfo: boolean;
  setShowInfo: (val: boolean) => void;

  showMore: any;
  setShowMore: (val: any) => void;

  isDirty: boolean;
  setIsDirty: (val: boolean) => void;

  edit: boolean;
  setEdit: (val: boolean) => void;

  selected: string;
  setSelected: (val: string) => void;

  reading: string;
  setReading: (val: string) => void;

  mapLayers: string[];
  setMapLayers: (val: string[]) => void;

  upgradeInProg: boolean;
  setUpgradeInProg: (val: boolean) => void;

  isEditingItem: boolean;
  setIsEditingItem: (val: boolean) => void;

  boundsFirstEdit: boolean;
  setBoundsFirstEdit: (val: boolean) => void;

  markerSize: number;
  setMarkerSize: (val: number) => void;

  opacity: number;
  setOpacity: (val: number) => void;
}

// --- Initial state for easy reset ---
export const mapControlInitialState: Omit<
  MapControlSlice,
  | 'setShowInfo'
  | 'setShowMore'
  | 'setIsDirty'
  | 'setEdit'
  | 'setSelected'
  | 'setReading'
  | 'setMapLayers'
  | 'setUpgradeInProg'
  | 'setIsEditingItem'
  | 'setBoundsFirstEdit'
  | 'setMarkerSize'
  | 'setOpacity'
> = {
  showInfo: false,
  showMore: null,
  isDirty: false,
  edit: false,
  selected: 'asset',
  reading: 'temperature',
  mapLayers: ['assets'],
  isEditingItem: false,
  upgradeInProg: false,
  boundsFirstEdit: true,
  markerSize: 45,
  opacity: 50,
};

export const createMapControlSlice: StateCreator<MapControlSlice> = (set, get, api) => ({
  ...mapControlInitialState,

  setShowInfo: (val) => set({ showInfo: val }),
  setShowMore: (val) => set({ showMore: val }),
  setIsDirty: (val) => set({ isDirty: val }),
  setEdit: (val) => set({ edit: val }),
  setSelected: (val) => set({ selected: val }),
  setReading: (val) => set({ reading: val }),
  setMapLayers: (val) => set({ mapLayers: val }),
  setUpgradeInProg: (val) => set({ upgradeInProg: val }),
  setIsEditingItem: (val) => set({ isEditingItem: val }),
  setBoundsFirstEdit: (val) => set({ boundsFirstEdit: val }),
  setMarkerSize: (val) => set({ markerSize: val }),
  setOpacity: (val) => set({ opacity: val }),
});
